import IndexPage from 'app'
import React from 'react'
import ReactDOM from 'react-dom'

ReactDOM.render(<IndexPage />, document.getElementById('root'))
